<template>
  <section id="card-text-alignment">
    <TrendyolProductSearch/>
    <Pagination :pagination="_pagination" @pageClick="getAll"/>
    <TrendyolProductItems/>
  </section>
</template>
<script>
import TrendyolProductSearch from "@/views/v2/trendyol/product/TrendyolProductSearch.vue";
import TrendyolProductItems from "@/views/v2/trendyol/product/TrendyolProductItems.vue";
import Pagination from "@/components/Pagination";
import {mapGetters} from "vuex";

export default {
  name: 'TrendyolProductHome',
  components: {TrendyolProductSearch, TrendyolProductItems, Pagination},
  computed: {
    ...mapGetters('tyProductV2', ['_pagination', '_search'])
  },
  methods: {
    getAll(page) {
      this._search.page = page;
      this.$store.dispatch('tyProductV2/getProducts')
    }
  }
}
</script>